import i18n from '@/api/i18n/i18n';

export const ROUTE_NAMES_FILES = {
  EXTERNAL_DRIVES: 'external-drives',
  SHADOW_COPYINGS: 'shadow-copyings',
  FILE_UPLOAD: 'file-upload',
};

export const ACTIVITY_FEED = 'activityFeed';
export const ROUTE_FILES = 'files';
export const ROUTE_WORKTIME_DETAILS = 'worktimeDetails';
export const ROUTE_HEAT_MAP = 'heatMap';
export const ROUTE_TRAFFIC_BY_GROUPS = 'trafficByGroups';
export const ROUTE_TRAFFIC_DETAILED = 'trafficDetailed';
export const PROGRAMS = 'programs';
export const WEBSITES = 'websites';
export const ADVANCED = 'advanced';

export const FILES_NAMES = Object.values(ROUTE_NAMES_FILES);
export const ROUTE_NAMES_AUTOTABLE = [ROUTE_FILES];
export const ROUTE_NAMES_SERVER_EXPORT_PDF = [PROGRAMS, WEBSITES, ACTIVITY_FEED, ADVANCED];

export const FORMAT_EXPORT = {
  PDF: 'pdf',
  XLS: 'xls',
  CSV: 'csv',
};
export const FILES_FORMAT_EXPORT = {
  PDF: 'pdf',
};

export const EXPORT_OPTIONS = Object.values(FORMAT_EXPORT);
export const FILES_EXPORT_OPTIONS = Object.values(FILES_FORMAT_EXPORT);

export const DATE_OPTIONS = [
  {
    id: 0,
    name: i18n.t('dateOptions.week'),
  },
  {
    id: 1,
    name: i18n.t('dateOptions.month'),
  },
  {
    id: 2,
    name: i18n.t('dateOptions.year'),
  },
  {
    id: 3,
    name: i18n.t('dateOptions.manual'),
  },
];

export const HEAT_MAP_COLORS = {
  0: '#E36363',
  1: '#F65151',
  2: '#FF5C5C',
  3: '#FF745C',
  4: '#FF841F',
  5: '#FF8F33',
  6: '#FFA733',
  7: '#FFBC47',
  8: '#FFDD33',
  9: '#FFFF1F',
  10: '#DCE700',
  11: '#D6FF0A',
  12: '#B0FF1F',
  13: '#6EF500',
  14: '#52DF16',
  15: '#2DB42D',
};

export const TRAFFIC_KIND_OPTIONS = [
  {
    id: 0,
    name: i18n.t('traffic.wholeTraffic'),
  },
  {
    id: 1,
    name: i18n.t('traffic.externalTraffic'),
  },
  {
    id: 2,
    name: i18n.t('traffic.localTraffic'),
  },
];

export const TRAFFIC_BY_GROUPS_COLUMNS = [
  { name: i18n.t('traffic.user'), field: 'nameUser', sort: 2 },
  { name: i18n.t('traffic.incoming'), field: 'sumTrafficIn', sort: 0 },
  { name: i18n.t('traffic.outgoing'), field: 'sumTrafficOut', sort: 0 },
  { name: i18n.t('traffic.siteTime'), field: 'duration', sort: 0 },
];

export const TRAFFIC_BY_PROCESSES_COLUMNS = [
  { title: i18n.t('traffic.process'), field: 'processName', sort: 2 },
  { title: i18n.t('traffic.incoming'), field: 'sumTrafficIn', sort: 0 },
  { title: i18n.t('traffic.outgoing'), field: 'sumTrafficOut', sort: 0 },
];

export const TRAFFIC_BY_ADDRESSES_COLUMNS = [
  { title: i18n.t('traffic.address'), field: 'address', sort: 2 },
  { title: i18n.t('traffic.incoming'), field: 'sumTrafficIn', sort: 0 },
  { title: i18n.t('traffic.outgoing'), field: 'sumTrafficOut', sort: 0 },
];

export const SITE_TIME_COLUMNS = [
  { name: i18n.t('traffic.group'), sort: 0, width: '2', field: 'group' },
  { name: i18n.t('traffic.domain'), sort: 0, width: '1', field: 'link' },
  { name: i18n.t('traffic.siteTime'), sort: 1, width: '1', field: 'duration' },
  { name: i18n.t('traffic.productivity'), sort: 0, width: '1', field: 'productivity' },
];

export const TRAFFIC_TABS = [
  {
    title: i18n.t('traffic.tabs.byProcesses'),
    active: true,
  },
  {
    title: i18n.t('traffic.tabs.byAddresses'),
    active: false,
  },
  {
    title: i18n.t('traffic.tabs.siteTime'),
    active: false,
  },
];

export const TRAFFIC_TABS_CHART = [
  {
    title: i18n.t('traffic.tabs.traffic'),
    active: true,
  },
  {
    title: i18n.t('traffic.tabs.siteTime'),
    active: false,
  },
];
